export default __webpack_public_path__ + "static/media/carinclined.51881c78.svg";